import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FlightLeg } from "../../Models/FlightLeg";

interface FlightScheduleState {
  flightPath: FlightLeg[];
}
const initialState: FlightScheduleState = {
  flightPath: {} as FlightLeg[],
};

export const FlightScheduleSlice = createSlice({
  name: "flightSchedule",
  initialState,
  reducers: {
    viewflightSchedule: (state, action: PayloadAction<FlightLeg[]>) => {
      state.flightPath = action.payload;
    },
  },
});

export default FlightScheduleSlice;
export const { viewflightSchedule } = FlightScheduleSlice.actions;